module.exports = __webpack_public_path__ + "img/T1A_rc_30.84807302.png";